import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const PricingSection = styled.section`
  padding: clamp(56px, 8vw, 100px) 0 clamp(64px, 10vw, 140px);
  background: #002107;
  scroll-margin-top: 0;
`

export const PricingWrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 clamp(16px, 4vw, 50px);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PricingHeading = styled.h2`
  color: #fff;
  font-size: clamp(26px, 4vw, 44px);
  line-height: 1.15;
  font-weight: 700;
  text-align: center;
  margin-bottom: 12px;
`

export const PricingSubheading = styled.p`
  color: #a1ff71;
  font-size: clamp(15px, 1.6vw, 18px);
  font-weight: 600;
  text-align: center;
  margin-bottom: clamp(28px, 4vw, 48px);
`

export const PricingContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;

  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: 680px;
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: 1fr;
    max-width: 380px;
    gap: 20px;
  }
`

export const PricingCard = styled.div`
  position: relative;
  background: #f3f3f3;
  border-radius: 14px;
  border: 3px solid ${({ $destaque }) => ($destaque ? '#a1ff71' : 'transparent')};
  box-shadow: ${({ $destaque }) =>
    $destaque
      ? '0 0 0 4px rgba(161, 255, 113, 0.2), 0 16px 40px rgba(0, 0, 0, 0.35)'
      : '0 10px 28px rgba(0, 0, 0, 0.3)'};
  transition: transform 0.3s ease-out;

  @media (hover: hover) {
    &:hover {
      transform: translateY(-6px);
    }
  }

  /* celular: o kit em destaque aparece primeiro */
  @media screen and (max-width: 560px) {
    order: ${({ $destaque }) => ($destaque ? -1 : 0)};
  }
`;

export const DestaqueBadge = styled.div`
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  background: #a1ff71;
  color: #002107;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.8px;
  padding: 6px 14px;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
`

export const PricingCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 28px 20px 24px;
  align-items: center;
  text-align: center;
  color: #000;
`

export const PricingCardIcon = styled.div`
  margin: 0 0 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    max-width: 150px;
    height: auto;
    object-fit: contain;
    transition: transform 0.3s ease;
    filter: drop-shadow(0 12px 18px rgba(0,0,0,0.25));
  }

  @media (hover: hover) {
    img:hover {
      transform: scale(1.05);
    }
  }

  @media screen and (max-width: 560px) {
    img {
      max-width: 130px;
    }
  }
`;

export const PricingCardPlan = styled.h3`
  font-size: 26px;
  font-weight: 900;
  color: #002107;
`

export const DiscountBadge = styled.span`
  display: inline-block;
  margin-top: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #1E8BB8;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
`

export const PriceBlock = styled.div`
  margin: 14px 0 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PricingCardCost = styled.p`
  font-size: clamp(34px, 3.2vw, 42px);
  font-weight: 900;
  line-height: 1.1;
  color: #002107;
`

export const PricingCardSubCost = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #333;

  b {
    font-weight: 700;
  }
`


/* ===== FRETE GRÁTIS ===== */

export const FreeShippingBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  margin: 12px 0 20px;

  padding: 6px 12px;
  border-radius: 20px;

  font-size: 12px;
  font-weight: 700;

  color: #1fa34a;
  background: #eaf8ef;

  width: fit-content;

  box-shadow: 0 2px 6px rgba(31,163,74,0.25);

  animation: pulse 2.4s infinite;

  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.06); }
    100% { transform: scale(1); }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/* ===== BOTÃO COMPRAR (LINK) ===== */


export const BuyButton = styled(Link)`
  margin-top: auto;
  width: 100%;
  display: block;

  background: #1fa34a;
  color: #fff;

  padding: 15px 20px;

  border-radius: 8px;

  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: center;

  text-decoration: none;

  box-shadow: 0 6px 16px rgba(31, 163, 74, 0.35);
  transition: all 0.25s ease;

  &:hover {
    background: #16883c;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
  }
`;
